import Button from '@atoms/Button';
import Image from '@atoms/Image';
import type { CountryCardProps } from '@molecules/CountryCard/CountryCard.types';
import Link from 'next/link';
import type { ReactElement } from 'react';

import { CardWrapper, ImageWrapper, TextWrapper } from './CountryCard.styled';

export const CountryCard = ({
  image,
  excerpt,
  title,
  link,
  buttonText,
  promoted = false,
}: CountryCardProps): ReactElement => (
  <Link href={link}>
    <CardWrapper promoted={promoted}>
      <ImageWrapper promoted={promoted}>
        <Image
          alt={image.alt}
          src={image.src}
          fill
          sizes="(max-width: 768px) 100vw, (max-width: 1140px) 50vw, 33vw"
        />
      </ImageWrapper>
      <TextWrapper promoted={promoted}>
        <h2>{title}</h2>
        <p>{excerpt}</p>
        {promoted && <Button>{buttonText}</Button>}
      </TextWrapper>
    </CardWrapper>
  </Link>
);
